import Icon from '../components/Icon.vue'

Icon.register({
  'solar-panel': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M432 448L384 448.1V416H256V448.2L208 448.3C199.2 448.3 192.1 455.4 192.1 464.3L192 496C192 504.8 199.2 512 208 512L432 511.7C440.8 511.7 448 504.6 448 495.8L448 464C448 455.2 440.8 448 432 448zM585.2 26.7C582.6 11.3 569 0 553.1 0H86.9C71 0 57.4 11.3 54.8 26.7-3.3 369.2 0 348.1 0 352 0 369.3 14.3 384 32.6 384H607.4C625.6 384 639.9 369.4 640 352.2 640 348.1 643.3 369.2 585.2 26.7zM259.8 64H380.2L389.9 160H250.1L259.8 64zM184.7 320H71.1L90.1 208H196.1L184.7 320zM200.9 160H98.2L114.5 64H210.7L200.9 160zM233.8 320L245.2 208H394.8L406.2 320H233.8zM429.3 64H525.5L541.8 160H439L429.3 64zM455.3 320L443.9 208H549.9L568.9 320H455.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/solar-panel.js
// module id = HjFN
// module chunks = 144